module.exports = __webpack_public_path__ + "img/map.ee40b2b9.png";